import * as tabTypes from '../../constants';
import { TABCOLORPALETTE } from '../../../selectedTab/constants';

const tabColorPaletteReducer = (state = TABCOLORPALETTE, action) => {
  switch (action.type) {
    case tabTypes.ADD_TAB:
    case tabTypes.SET_COLOR:
    case tabTypes.DUPLICATE_TAB:
      return action.tabData.tabColorPalette;
    default:
      return state;
  }
};

export default tabColorPaletteReducer;

export const getColorPalette = (state, tabIndex) => {
  const selectedTab = tabIndex != null ? tabIndex : state.selectedTab;
  return state.tabs[selectedTab].tabColorPalette;
};
